import { defineMessages } from "react-intl";

export const messages = defineMessages({
  discountProductsHeader: {
    id: "xqXYF+",
    defaultMessage: "Eligible Products",
    description: "section header",
  },
  discountProductsButton: {
    id: "U8eeLW",
    defaultMessage: "Assign products",
    description: "button",
  },
  discountProductsTableProductHeader: {
    id: "6cMkfT",
    defaultMessage: "Product Name",
    description: "table head",
  },
  discountProductsTableTypeHeader: {
    id: "bPFp8B",
    defaultMessage: "Product Type",
    description: "product type",
  },
  discountProductsTableAvailabilityHeader: {
    id: "Oe62bR",
    defaultMessage: "Availability",
    description: "product availability",
  },
  discountProductsNotFound: {
    id: "OrR3Qy",
    defaultMessage: "No products found",
    description: "no products",
  },
});
